module.exports = __webpack_public_path__ + "static/media/Piliv1.1.687ba5d3.glb";